import { api } from '@/lib/api';
import { SaveTemplateDto } from '@/lib/ServerApi';
import { CustomCellRendererProps } from '@ag-grid-community/react';
import { Flex, Textarea, Button, Box, Text } from '@chakra-ui/react';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { useRevalidator } from 'react-router-dom';

export const TemplatesDescriptionRenderer = ({ data: rowData }: CustomCellRendererProps) => {
    const [editing, setEditing] = useState(false);
    const [newTitle, setNewTitle] = useState(rowData?.title || '');
    const [newDescription, setNewDescription] = useState(rowData?.description || '');
    const { revalidate } = useRevalidator();

    const { mutate: saveTemplate } = useMutation<unknown, unknown, SaveTemplateDto>({
        mutationFn: async (body) => {
            return api.template.save(body);
        },
        onSettled: () => {
            revalidate();
        },
    });

    return !editing ? (
        <Box onDoubleClick={() => setEditing(true)} lineHeight="20px" py="2">
            <Text fontWeight="medium">{rowData?.title}</Text>
            {rowData?.description && (
                <Text color="gray.600" fontSize="sm">
                    {rowData?.description}
                </Text>
            )}
        </Box>
    ) : (
        <Flex flexDir="column" gap="1" lineHeight={0} py="2">
            <Textarea height={30} value={newTitle} onChange={(e) => setNewTitle(e.target.value)} placeholder="Title" />
            <Textarea height={40} value={newDescription} onChange={(e) => setNewDescription(e.target.value)} placeholder="Description" />
            <Flex justifyContent="end" gap="2">
                <Button
                    type="button"
                    size="xs"
                    onClick={() => {
                        saveTemplate({
                            ...rowData,
                            title: newTitle,
                            description: newDescription,
                        });
                        setEditing(false);
                    }}>
                    Save
                </Button>
                <Button type="button" variant="outline" size="xs" onClick={() => setEditing(false)}>
                    Cancel
                </Button>
            </Flex>
        </Flex>
    );
};
